export const facilities = [
  {
    id: 'tx-1',
    name: 'Texas Mega Facility',
    location: 'Austin, Texas',
    country: 'United States',
    capacity: '100 MW',
    powerSource: 'Wind & Solar',
    powerCost: 0.065,
    minOrder: 10,
    features: [
      '24/7 On-site Security',
      'Redundant Power Systems',
      'Advanced Cooling',
      'Remote Management',
      'Technical Support'
    ],
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'enterprise',
    uptime: 99.99,
    quality_score: 5,
    certifications: ['ISO 27001', 'SOC 2', 'Tier 4'],
    description: 'State-of-the-art mining facility powered by renewable energy, featuring advanced security measures and comprehensive support services.',
    amenities: [
      'On-site Technical Staff',
      'Backup Generators',
      '24/7 Video Surveillance',
      'Biometric Access Control',
      'Fire Suppression System'
    ],
    powerDetails: {
      sources: ['Wind Farm', 'Solar Array'],
      backupType: 'Natural Gas Generators',
      gridConnection: 'Redundant'
    },
    cooling: {
      type: 'Immersion + Air',
      efficiency: 'PUE 1.02',
      capacity: '12 MW'
    },
    measureX: {
      ready: true,
      version: '2.1',
      features: ['Remote Monitoring', 'Automated Optimization', 'Predictive Maintenance']
    }
  },
  {
    id: 'wy-1',
    name: 'Wyoming Green Mining',
    location: 'Cheyenne, Wyoming',
    country: 'United States',
    capacity: '75 MW',
    powerSource: 'Hydroelectric',
    powerCost: 0.055,
    minOrder: 8,
    features: [
      '24/7 Security',
      'Redundant Cooling',
      'Remote Management',
      'On-site Support'
    ],
    image: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'advanced',
    uptime: 99.95,
    quality_score: 4,
    certifications: ['ISO 27001', 'Tier 3'],
    description: 'Eco-friendly mining facility powered by clean hydroelectric energy, offering reliable infrastructure and professional management.',
    amenities: [
      'On-site Security',
      'Backup Power',
      'CCTV Monitoring',
      'Card Access System'
    ],
    powerDetails: {
      sources: ['Hydroelectric Dam'],
      backupType: 'Diesel Generators',
      gridConnection: 'Single'
    },
    cooling: {
      type: 'Air-cooled',
      efficiency: 'PUE 1.08',
      capacity: '8 MW'
    },
    measureX: {
      ready: true,
      version: '2.0',
      features: ['Remote Monitoring', 'Basic Optimization']
    }
  },
  {
    id: 'ice-1',
    name: 'Iceland Arctic Mining',
    location: 'Reykjavik',
    country: 'Iceland',
    capacity: '150 MW',
    powerSource: 'Geothermal',
    powerCost: 0.045,
    minOrder: 15,
    features: [
      '24/7 Security',
      'Natural Cooling',
      'Green Energy',
      'Remote Management',
      'Technical Support',
      'Immersion Cooling Option'
    ],
    image: 'https://images.unsplash.com/photo-1516544820488-4a99efa70a58?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'enterprise',
    uptime: 99.98,
    quality_score: 5,
    certifications: ['ISO 27001', 'SOC 2', 'Tier 4', 'Green Energy Certified'],
    description: 'State-of-the-art facility leveraging Iceland\'s natural advantages with geothermal power and natural cooling.',
    amenities: [
      'On-site Technical Team',
      'Redundant Power',
      'Advanced Security',
      'Climate Control'
    ],
    powerDetails: {
      sources: ['Geothermal Plant'],
      backupType: 'Geothermal Redundancy',
      gridConnection: 'Direct'
    },
    cooling: {
      type: 'Natural + Immersion',
      efficiency: 'PUE 1.03',
      capacity: '15 MW'
    },
    measureX: {
      ready: true,
      version: '2.1',
      features: ['Remote Monitoring', 'Automated Optimization', 'Energy Efficiency Tracking']
    }
  },
  {
    id: 'kz-1',
    name: 'Kazakhstan Mining Hub',
    location: 'Nur-Sultan',
    country: 'Kazakhstan',
    capacity: '200 MW',
    powerSource: 'Natural Gas & Solar',
    powerCost: 0.035,
    minOrder: 20,
    features: [
      '24/7 Armed Security',
      'Hybrid Cooling Systems',
      'Remote Management',
      'On-site Engineers',
      'Bulk Hosting Discounts'
    ],
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'advanced',
    uptime: 99.90,
    quality_score: 4,
    certifications: ['ISO 27001', 'Tier 3'],
    description: 'Large-scale mining facility offering competitive rates and professional management in Central Asia.',
    amenities: [
      'Armed Security',
      'Engineering Support',
      'Bulk Discounts',
      'Custom Solutions'
    ],
    powerDetails: {
      sources: ['Natural Gas Plant', 'Solar Farm'],
      backupType: 'Diesel Generators',
      gridConnection: 'Redundant'
    },
    cooling: {
      type: 'Hybrid Air + Water',
      efficiency: 'PUE 1.15',
      capacity: '20 MW'
    },
    measureX: {
      ready: true,
      version: '2.0',
      features: ['Remote Monitoring', 'Basic Optimization']
    }
  },
  {
    id: 'ca-1',
    name: 'Quebec Hydro Mining',
    location: 'Montreal',
    country: 'Canada',
    capacity: '120 MW',
    powerSource: 'Hydroelectric',
    powerCost: 0.052,
    minOrder: 12,
    features: [
      '24/7 Security',
      'Cold Climate Optimization',
      'Remote Management',
      'Bilingual Support',
      'Custom Rack Design'
    ],
    image: 'https://images.unsplash.com/photo-1609743522653-52354461eb27?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'enterprise',
    uptime: 99.97,
    quality_score: 5,
    certifications: ['ISO 27001', 'SOC 2', 'Tier 4', 'Hydro-Quebec Certified'],
    description: 'Premium Canadian facility leveraging clean hydroelectric power and cold climate advantages.',
    amenities: [
      'Bilingual Support',
      'Custom Racks',
      'Cold Climate Optimized',
      'Enterprise Security'
    ],
    powerDetails: {
      sources: ['Hydro-Quebec Grid'],
      backupType: 'Redundant Grid',
      gridConnection: 'Enterprise'
    },
    cooling: {
      type: 'Cold Climate + Air',
      efficiency: 'PUE 1.05',
      capacity: '12 MW'
    },
    measureX: {
      ready: true,
      version: '2.1',
      features: ['Remote Monitoring', 'Automated Optimization', 'Cold Weather Adaptation']
    }
  },
  {
    id: 'ge-1',
    name: 'Georgia Power Hub',
    location: 'Tbilisi',
    country: 'Georgia',
    capacity: '85 MW',
    powerSource: 'Hydroelectric & Solar',
    powerCost: 0.048,
    minOrder: 10,
    features: [
      '24/7 Security',
      'Mixed Cooling Systems',
      'Remote Management',
      'Multi-language Support',
      'Flexible Contracts'
    ],
    image: 'https://images.unsplash.com/photo-1548613053-22087dd8edb8?auto=format&fit=crop&q=80',
    status: 'active',
    securityLevel: 'advanced',
    uptime: 99.93,
    quality_score: 4,
    certifications: ['ISO 27001', 'Tier 3'],
    description: 'Strategic facility combining hydroelectric and solar power with modern infrastructure.',
    amenities: [
      'Multi-language Support',
      'Flexible Terms',
      'Mixed Cooling',
      'Professional Security'
    ],
    powerDetails: {
      sources: ['Hydro Plant', 'Solar Array'],
      backupType: 'Grid + Generator',
      gridConnection: 'Dual Feed'
    },
    cooling: {
      type: 'Mixed Air + Water',
      efficiency: 'PUE 1.12',
      capacity: '9 MW'
    },
    measureX: {
      ready: true,
      version: '2.0',
      features: ['Remote Monitoring', 'Basic Optimization', 'Power Usage Analytics']
    }
  }
];